"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/promise"));

var _setInterval2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set-interval"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _find = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find"));

var _react = _interopRequireDefault(require("react"));

var _Nav = _interopRequireDefault(require("reactstrap/lib/Nav"));

var _NavItem = _interopRequireDefault(require("reactstrap/lib/NavItem"));

var _NavLink = _interopRequireDefault(require("reactstrap/lib/NavLink"));

var _UncontrolledCollapse = _interopRequireDefault(require("reactstrap/lib/UncontrolledCollapse"));

var _ChevronsmallrightGreyOutline = _interopRequireDefault(require("@druva-apps/orion-icons/lib/ChevronsmallrightGreyOutline"));

var _tooltip = _interopRequireDefault(require("../tooltip"));

var _icon = _interopRequireDefault(require("../icon/icon"));

var _utils = require("./utils");

/* eslint-disable react/jsx-fragments */
var findElement = function findElement(index) {
  return new _promise["default"](function (resolve) {
    var checkExist = (0, _setInterval2["default"])(function findCollapsibleElement() {
      var el = document.querySelector("#fg-collapse-".concat(index));

      if (el && el instanceof HTMLElement) {
        resolve(el);
        clearInterval(checkExist);
      }
    }, 10);
  });
};

var SidenavUtils = /*#__PURE__*/(0, _createClass2["default"])(function SidenavUtils() {
  var _this = this;

  (0, _classCallCheck2["default"])(this, SidenavUtils);
  (0, _defineProperty2["default"])(this, "renderSideNav", function (props) {
    var _context;

    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, (0, _map["default"])(_context = props.items).call(_context, function (item, index) {
      if ((0, _utils.hasProperty)(item, "heading")) {
        return /*#__PURE__*/_react["default"].createElement(_Nav["default"], {
          vertical: true,
          key: "nav-".concat(index),
          className: "oui-mw-100"
        }, _this.renderHeadingItems(props, item, index));
      }

      if ((0, _utils.hasProperty)(item, "collapsible") && item.collapsible === true) {
        return /*#__PURE__*/_react["default"].createElement(_Nav["default"], {
          vertical: true,
          key: "nav-".concat(index),
          className: "oui-mw-100"
        }, _this.renderCollapsibleItem(props, item, index));
      }

      if ((0, _utils.hasProperty)(item, "collapsible") && item.collapsible === false) {
        return /*#__PURE__*/_react["default"].createElement(_Nav["default"], {
          vertical: true,
          key: "nav-".concat(index),
          className: "oui-mw-100"
        }, _this.renderExpandedItem(props, item, index));
      }

      if ((0, _utils.hasProperty)(item, "items")) {
        return /*#__PURE__*/_react["default"].createElement(_Nav["default"], {
          vertical: true,
          key: "nav-".concat(index),
          className: "oui-mw-100"
        }, _this.renderChildItems(props, item.items, index));
      }

      return /*#__PURE__*/_react["default"].createElement(_Nav["default"], {
        vertical: true,
        key: "nav-".concat(index),
        className: "oui-mw-100"
      }, _this.renderItem(props, item, index));
    }));
  });
  (0, _defineProperty2["default"])(this, "renderItem", function (props, item, index, isInnerLink) {
    if ((0, _utils.hasProperty)(item, "items") && item.items.length > 0) {
      return _this.renderCollapsibleItem(props, item, index, true);
    }

    return /*#__PURE__*/_react["default"].createElement(_NavItem["default"], {
      key: index,
      className: "oui-mw-100"
    }, (0, _utils.isFunction)(item.renderComponent) ? item.renderComponent(item, index, "oui-active", isInnerLink ? "oui-nav-link oui-nav-link-inner" : "oui-nav-link") : /*#__PURE__*/_react["default"].createElement(_NavLink["default"], (0, _extends2["default"])({
      className: (0, _utils.gatherClasses)(null, "oui-mw-100", item.isActive ? "oui-active" : null, isInnerLink ? "oui-nav-link-inner" : null, "oui-d-flex oui-justify-content-between oui-align-items-center"),
      onClick: function onClick(e) {
        if ((0, _utils.isFunction)(props.onItemClick)) {
          props.onItemClick(item, e);
        }
      }
    }, (0, _utils.gatherConditionalProps)(item, "href", "disabled", "target")), /*#__PURE__*/_react["default"].createElement(_tooltip["default"], {
      text: item.name,
      overflowOnly: true
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "oui-text-truncate"
    }, item.icon ? /*#__PURE__*/_react["default"].isValidElement(item.icon) ? /*#__PURE__*/_react["default"].cloneElement(item.icon, {
      className: (0, _utils.gatherClasses)(null, "oui-menu-icon", item.icon.props.className)
    }) : /*#__PURE__*/_react["default"].createElement(_icon["default"], (0, _extends2["default"])({}, item.icon, {
      className: (0, _utils.gatherClasses)(item.icon, "oui-menu-icon")
    })) : null, item.name)), (0, _utils.isFunction)(item.extras) ? /*#__PURE__*/_react["default"].createElement("div", {
      className: "oui-extras oui-d-inline-block oui-ml-2"
    }, item.extras()) : null));
  });
  (0, _defineProperty2["default"])(this, "renderChildItems", function (props, items, index) {
    var isInnerLink = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    return (0, _map["default"])(items).call(items, function (item, ind) {
      var _context2;

      return _this.renderItem(props, item, (0, _concat["default"])(_context2 = "".concat(index, "-")).call(_context2, ind), isInnerLink);
    });
  });
  (0, _defineProperty2["default"])(this, "renderHeadingItems", function (props, item, index) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
      key: "fg-".concat(index)
    }, /*#__PURE__*/_react["default"].createElement("li", {
      className: "oui-h6 oui-group-header"
    }, item.heading), _this.renderChildItems(props, item.items, index));
  });
  (0, _defineProperty2["default"])(this, "renderExpandedItem", function (props, item, index) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
      key: "fg-".concat(index)
    }, /*#__PURE__*/_react["default"].createElement(_NavItem["default"], {
      className: "oui-mw-100"
    }, (0, _utils.isFunction)(item.renderComponent) ? item.renderComponent() : /*#__PURE__*/_react["default"].createElement(_tooltip["default"], {
      text: item.name,
      overflowOnly: true
    }, /*#__PURE__*/_react["default"].createElement(_NavLink["default"], {
      id: "fg-collapse-".concat(index),
      href: "#",
      className: "oui-mw-100 oui-collapse-trigger-link oui-text-truncate"
    }, item.icon ? /*#__PURE__*/_react["default"].isValidElement(item.icon) ? /*#__PURE__*/_react["default"].cloneElement(item.icon, {
      className: (0, _utils.gatherClasses)(null, "oui-menu-icon", item.icon.props.className)
    }) : /*#__PURE__*/_react["default"].createElement(_icon["default"], (0, _extends2["default"])({}, item.icon, {
      className: (0, _utils.gatherClasses)(item.icon, "oui-menu-icon")
    })) : null, item.name))), /*#__PURE__*/_react["default"].createElement("ul", {
      className: "oui-collapse-container oui-mw-100"
    }, _this.renderChildItems(props, item.items, index, true)));
  });
  (0, _defineProperty2["default"])(this, "renderCollapsibleItem", function (props, item, index) {
    var _context3;

    var showExpanded = !!(item.items && (0, _find["default"])(_context3 = item.items).call(_context3, function (it) {
      return it.isActive === true;
    }));

    function toggleClass() {
      var el = document.querySelector("#fg-collapse-".concat(index));

      if (el && el.classList.contains("oui-expanded")) {
        el.classList.remove("oui-expanded");

        if (showExpanded) {
          el.classList.add("oui-active");
        }
      } else {
        el.classList.add("oui-expanded");
        el.classList.remove("oui-active");
      }
    }

    var foundElement = findElement(index);

    if (showExpanded === true) {
      foundElement.then(function (el) {
        if (!el.classList.contains("oui-expanded")) {
          el.click();
        }
      });
    }

    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
      key: "fg-".concat(index)
    }, /*#__PURE__*/_react["default"].createElement(_NavItem["default"], {
      className: "oui-mw-100"
    }, /*#__PURE__*/_react["default"].createElement(_NavLink["default"], {
      id: "fg-collapse-".concat(index),
      href: "#",
      onClick: toggleClass,
      className: "oui-collapse-trigger-link oui-mw-100 oui-d-flex oui-justify-content-between oui-align-items-center"
    }, /*#__PURE__*/_react["default"].createElement(_tooltip["default"], {
      text: item.name,
      overflowOnly: true
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "oui-text-truncate"
    }, item.icon ? /*#__PURE__*/_react["default"].isValidElement(item.icon) ? /*#__PURE__*/_react["default"].cloneElement(item.icon, {
      className: (0, _utils.gatherClasses)(null, "oui-menu-icon", item.icon.props.className)
    }) : /*#__PURE__*/_react["default"].createElement(_icon["default"], (0, _extends2["default"])({}, item.icon, {
      className: (0, _utils.gatherClasses)(item.icon, "oui-menu-icon")
    })) : null, item.name)), /*#__PURE__*/_react["default"].createElement("span", {
      className: "oui-collapse-icon"
    }, /*#__PURE__*/_react["default"].createElement(_ChevronsmallrightGreyOutline["default"], {
      inheritFontColor: true,
      size: "md"
    })))), /*#__PURE__*/_react["default"].createElement(_UncontrolledCollapse["default"], {
      tag: "li",
      toggler: "#fg-collapse-".concat(index),
      className: "oui-mw-100"
    }, /*#__PURE__*/_react["default"].createElement("ul", {
      className: "oui-collapse-container oui-mw-100"
    }, _this.renderChildItems(props, item.items, index, true))));
  });
});
exports["default"] = SidenavUtils;